module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page_container"
  }, [_c('ul', {
    staticClass: "nav page"
  }, [(!_vm.page.firstPage) ? _c('li', {
    staticClass: "single_page",
    on: {
      "click": function($event) {
        _vm.goto(_vm.page.pageNumber - 1)
      }
    }
  }, [_vm._v("上一页")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.page.shown), function(n) {
    return _c('li', {
      staticClass: "specified_page",
      class: {
        selected: n == _vm.page.pageNumber - _vm.page.startPage + 1
      },
      on: {
        "click": function($event) {
          _vm.goto(n + _vm.page.startPage - 1)
        }
      }
    }, [_vm._v("\n      " + _vm._s(n + _vm.page.startPage - 1) + "\n    ")])
  }), _vm._v(" "), (!_vm.page.lastPage) ? _c('li', {
    staticClass: "single_page",
    on: {
      "click": function($event) {
        _vm.goto(_vm.page.pageNumber + 1)
      }
    }
  }, [_vm._v("下一页")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78f3fb7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Paging.vue
// module id = 774
// module chunks = 1